module.exports = __webpack_public_path__ + "img/1-22-5.b11e71f6.png";